import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import Loading from 'components/global/Loading';

import useFedCM from 'pages/Login/useFedCM';

const AutoLoginChecker = ({ children }) => {
	const [searchParams, setSearchParams] = useSearchParams();
	const { handleGoogleLogin } = useFedCM(true);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const googleFedCMToken = searchParams.get('googleFedCMToken');

		if (googleFedCMToken) {
			setSearchParams({});
			handleGoogleLogin({ credential: googleFedCMToken }).then(() => setLoading(false));
		} else {
			setLoading(false);
		}
	}, []);

	return loading ? <Loading /> : children;
};

export default AutoLoginChecker;
